export default  {
  template: require('../views/logoWords.html')
};


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/logoWords.component.js